/* eslint-disable operator-linebreak */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable arrow-body-style */
/* eslint-disable max-len */
/* eslint-disable import/no-unresolved */
import { useMutation } from '@tanstack/react-query';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import { useFetchPosProfileDetails } from '../user';
import { selectAuth, selectCart, selectOrder } from '@/store/selectors';
import { setAlert } from '@/store/slices/alert';
import { NewKOTType, UpdateKOTType } from '@/types/utils';
import {
  updateInvoice,
  addCustomer,
  updateTax,
  updateDiscount,
  updateSubTotal,
  updateTotal,
  toogleServiceCharge,
} from '@/store/slices/order';
import { openModal } from '@/store/slices/modal';
import { handleApiError } from '@/utils/helpers';

// eslint-disable-next-line @typescript-eslint/no-explicit-any

const fetcher = (
  url: any,
  invoiceData: NewKOTType | UpdateKOTType,
  serviceCharge: boolean,
) => {
  const response = axios({
    method: 'post',
    url: `https://${url}/api/method/oyasync_integrations.oyasync_integrations.api.pos_app.pos_app.save_draft_invoice`,
    data: {
      use_service_charge: serviceCharge ? 1 : 0,
      data: { ...invoiceData },
    },
    withCredentials: true,
  })
    .then((data) => data)
    .catch((error) => error);

  return response;
};

// eslint-disable-next-line import/prefer-default-export
export const useSaveInvoice = () => {
  const { url } = useSelector(selectAuth);
  const { data: posProfile } = useFetchPosProfileDetails();
  const { items, subtotal } = useSelector(selectCart);
  const {
    restaurant_table,
    customer,
    discount,
    service_charge,
    selected_pump: pump,
    toggle_dispense_pump: togglePump,
  } = useSelector(selectOrder);
  const dispatch = useDispatch();

  const invoiceData: NewKOTType = {
    company: posProfile?.company,
    restaurant: posProfile?.restaurant,
    restaurant_table,
    discount_amount: discount,
    customer,
    subtotal,
    items,
    pos_profile: posProfile,
    custom_wallet: 1,
    dispense_point: togglePump ? pump ?? '' : '',
  };

  const handleSuccess = (data: any) => {
    dispatch(updateSubTotal(data.total));
    dispatch(updateTotal(data.grand_total));
    dispatch(updateInvoice(data.name));
    dispatch(addCustomer(data.customer));
    dispatch(updateTax(data.taxes));
    dispatch(updateDiscount(data.discount_amount));
    dispatch(toogleServiceCharge(false));

    dispatch(openModal({ type: 'submitPayment' }));
  };

  const handleError = (message: string) => {
    dispatch(setAlert({ type: 'error', message }));
  };

  const mutate = useMutation(() => fetcher(url, invoiceData, service_charge), {
    onSettled: (data) => {
      if (!data.data) {
        const errorMessage = handleApiError(data);
        handleError(errorMessage);
      } else if (data.data) {
        handleSuccess(data.data?.message);
      }
    },
    onError: () => handleError('An Error Occured. Contact Administration'),
  });

  return mutate;
};
